import { render } from "./KnowledgeGraphEditorJointJS.vue?vue&type=template&id=2169a1ad&scoped=true"
import script from "./KnowledgeGraphEditorJointJS.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraphEditorJointJS.vue?vue&type=script&lang=js"

import "./KnowledgeGraphEditorJointJS.vue?vue&type=style&index=0&id=2169a1ad&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2169a1ad"]])

export default __exports__